export default {
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    loading: 'Loading...',
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Info'
  },
  
  // Navigation
  nav: {
    home: 'Home',
    Vision: 'Vision',
    Platforms: 'Products & Platforms',
    Services: 'Our Services',
    Cases: 'Cases',
    About: 'About',
    settings: 'Settings',
    profile: 'Profile',
    logout: 'Logout',
    contact: 'Contact'
  },
  txt: {
    t1: 'Make Every Business Process Smarter',
    t2: 'Enterprise-grade AI Agents · Driving Business Innovation',

    t4: 'AI Empowers Enterprise Applications · Leading the Intelligent Future', 
    t41: 'As digitalization deepens, AI becomes the new engine for enterprise IT.',
    t5: 'AI-infused apps grasp business logic, anticipate trends, and automate complex workflows for sharper efficiency.',
    t6: 'Ifloop\'s AI agent platform fuses NLU, knowledge graphs, RPA, and data intelligence to rejuvenate ERP, MES, CRM, finance, and supply chain systems.',
    t7: 'AI now runs operations, propelling the shift from IT to intelligence and making every workflow smarter.', 
    
    t9: '案例包括：Case studies include: Sinoma Technology, Shandong Energy, Yanfeng International, Wanhua Chemical, Wanda Boiler, etc.',
    t11: 'ITIL-based managed services, supporting SAP and in-house systems.',
    t12: 'Enterprise AI agent hosting, intelligent system upgrades and migration, version iterations.',


    t13: 'IF-AI · Ifloop Enterprise AI Platform',
    t14: 'IF-IDP · Intelligent Document Processing',
    t15: 'IF-SCC · Supply Chain Collaboration',
    t16: 'IF-IMS · Digital Factory Management',

    t17: 'Intelligent solutions consulting',
    t18: 'Digital transformation and architecture planning aligned to business goals.',
    t19: 'AI upgrade roadmaps for manufacturing, energy, chemical, high‑tech.',
    t20: 'Enterprise app implementation',
    t21: 'End‑to‑end delivery: design, build, deploy.',
    t22: 'Procurement, production, quality, finance, records—reliable, scalable systems.',
    t23: 'Build enterprise AI agents',
    t24: 'Deep AI–business integration; tailored agent platforms.',
    t25: 'NL chat, QA, automation, insights—smart assistants and decisions.',
    t26: 'Operate and optimize enterprise apps',
    t27: 'ITIL‑based ops and optimization.',
    t28: 'Support SAP/custom: run, upgrade, performance; iterate AI agents.',

    t29: 'About Us',
    t30: 'Ifloop Technology Co., Ltd. was founded in 2017, focusing on enterprise information and intelligent transformation. With core technologies such as big data, AI agents, industrial internet, and cloud computing, we provide end‑to‑end solutions from digital management to AI‑driven decision‑making. Through years of accumulation, we have provided high‑quality IT implementation services to over ten major clients and maintained long‑term system maintenance for many enterprises. Our service industries cover energy, traditional manufacturing, chemical, and high‑tech sectors, and we have established stable cooperative relationships with some industry leaders.'
    
    ,
    // New: Products & Platforms section
    pp_title: 'AI‑driven transformation—making every workflow smarter. ',
    pp_intro: 'Ifloop delivers an integrated path from digital management to AI‑driven decisions via our platform and industry products.',
    core_features: 'Core features:',

    // IF-AI
    ai: {
      desc: 'Custom and managed enterprise AI platform—your intelligent core across process, data, and services.',
      f1: 'Knowledge QA—NL chat and retrieval',
      f2: 'Analytics—multi‑dim insights and reports',
      f3: 'AI Assistants—cross‑system tasks and automation'
    },
    // IF-IDP
    idp: {
      desc: 'Faster, accurate docs and records. OCR, RPA, and KG automate processing and digitize lifecycles.',
      f1: 'Auto classify and recognize documents',
      f2: 'Smart routing and approvals',
      f3: 'Full lifecycle tracking and audit'
    },
    // IF-SCC
    scc: {
      desc: 'Collaborative, intelligent supply chain from orders to reconciliation, end‑to‑end online.',
      f1: 'Orders, shipping, invoicing, reconciliation',
      f2: 'Real‑time sharing and tracking',
      f3: 'Multi‑org roles and access control'
    },
    // IF-IMS
    ims: {
      desc: 'AI + IIoT for visible, digital factories—more transparent, smarter manufacturing.',
      f1: 'Smart planning and scheduling',
      f2: 'Equipment monitoring and maintenance alerts',
      f3: 'Quality traceability and analytics'
    }
  },
  
  // Page titles
  page: {
    home: 'Home',
    about: 'About Us',
    welcome: 'Welcome to Management System'
  },
  
  // Form
  form: {
    username: 'Username',
    password: 'Password',
    email: 'Email',
    phone: 'Phone',
    name: 'Name',
    address: 'Address',
    description: 'Description',
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPhone: 'Please enter a valid phone number',
    minLength: 'Minimum {min} characters required',
    maxLength: 'Maximum {max} characters allowed'
  },
  
  // Messages
  message: {
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    logoutSuccess: 'Logout successful',
    saveSuccess: 'Save successful',
    deleteSuccess: 'Delete successful',
    updateSuccess: 'Update successful',
    networkError: 'Network connection error',
    serverError: 'Server error',
    unauthorized: 'Unauthorized access',
    forbidden: 'Access forbidden',
    notFound: 'Page not found'
  }
}
